export default class Loader {
  static async process(predicate, message) {
    Loader.show(message);
    try {
      return await predicate();
    } catch (error) {
      console.error('Error:', error);
      throw error;
    } finally {
      Loader.hide();
    }
  }

  static getLoader() {
    let loader = document.getElementById('loader');
    if (!loader) {
      loader = document.createElement('span');
      loader.id = 'loader';
      loader.setAttribute('aria-busy', 'true');
      loader.style.display = 'none';
      loader.style.position = 'absolute';
      loader.style.top = '0';
      loader.style.alignSelf = 'center';
      document.body.appendChild(loader);
    }
    return loader;
  }

  static show(message = 'Loading...') {
    const loader = Loader.getLoader();
    loader.innerHTML = message;
    loader.style.display = 'block';
  }
  static hide() {
    const loader = Loader.getLoader();
    if (loader) {
      loader.style.display = 'none';
    }
  }
  static toggle() {
    const loader = document.getElementById('loader');
    if (loader) {
      this.hide();
    } else {
      this.show();
    }
  }
  static isVisible() {
    const loader = document.getElementById('loader');
    return loader !== null;
  }
  static remove() {
    const loader = document.getElementById('loader');
    if (loader) {
      document.body.removeChild(loader);
      document.body.style.overflow = '';
    }
  }
}
